module.exports = __webpack_public_path__ + "static/pinkfloralbunny-d09156365830ce980adbd7948ab00fc7.jpeg";